import { gql } from "@apollo/client";

export const REMOVE_VENUE_STREAM = gql`
  mutation removeVenueStreams($id: Int!) {
    removeVenueStreams(id: $id) {
      message
    }
  }
`;
